module.exports = __webpack_public_path__ + "static/media/starter-mr-card-front.2aa71f9b.jpeg";